var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import _ from 'lodash';
import { ChunkType } from './types';
export const API_BASE_URL = ''.replace(/\/\s*$/, '');
export const FAILURE_CHUNK_MESSAGE = "I'm sorry, but something went wrong. Can you please try again?";
export const readStream = (stream, onData) => {
    return new Promise(resolve => {
        const reader = stream.getReader();
        const process = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const { done, value } = yield reader.read();
                const decodedChunk = new TextDecoder().decode(value);
                if (decodedChunk) {
                    onData(decodedChunk);
                }
                if (done) {
                    onData('', true);
                    resolve();
                }
                else {
                    yield process();
                }
            }
            catch (error) {
                console.error('Error reading stream:', error);
                onData(`<---${JSON.stringify({ [ChunkType.ERROR]: FAILURE_CHUNK_MESSAGE })}--->`, true);
                resolve();
            }
        });
        void process();
    });
};
export const getHeadersForFrontendCall = () => ({
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Cookie: document.cookie,
    'X-CSRF-Token': _.get(document.querySelector('meta[name="csrf-token"]'), 'content', ''),
    'X-App-Token': _.get(window, 'serverConfig.appToken', ''),
});
export const getValuesFromChunk = (chunk, key, config) => {
    const pattern = new RegExp(`<---\\{\\s*"${key}".*?\\}--->`, 'g');
    const objects = chunk.match(pattern);
    const extractedObjects = objects === null || objects === void 0 ? void 0 : objects.map(obj => {
        const match = obj.match(/<---(.*?)--->/);
        return match ? match[1] : '';
    });
    if (extractedObjects) {
        const { listOfBannedWords, redactedText } = config;
        const excludeWords = listOfBannedWords && (listOfBannedWords || '').split(',').map(word => word.trim());
        let messages;
        try {
            messages = extractedObjects === null || extractedObjects === void 0 ? void 0 : extractedObjects.map(obj => {
                const parsedObject = JSON.parse(obj);
                const parsedMessage = parsedObject[key] || '';
                return parsedMessage;
            });
        }
        catch (error) {
            console.error('Failed to get values from chunk: ', error);
            return { value: FAILURE_CHUNK_MESSAGE, type: ChunkType.ERROR };
        }
        const result = key === ChunkType.PROGRESS_STATUS ? ((messages === null || messages === void 0 ? void 0 : messages.length) > 0 ? messages[messages.length - 1] : '') : (messages || '').join('');
        if (excludeWords && excludeWords.length > 0) {
            const pattern = new RegExp(`\\b(${excludeWords.join('|')})\\b`, 'gi');
            const parsedResult = result.replace(pattern, (redactedText || '') + '');
            return { value: parsedResult, type: key };
        }
        else {
            return { value: result, type: key };
        }
    }
    return null;
};
export const getActionFunctionFromChunk = (chunk) => {
    const objects = chunk.match(/<--{"windowFunctions.*?\]\}-->/g);
    const extractedObjects = objects === null || objects === void 0 ? void 0 : objects.map(obj => {
        const match = obj.match(/<--(.*?)-->/);
        return match ? match[1] : null;
    });
    if (extractedObjects) {
        const actionFunctions = extractedObjects === null || extractedObjects === void 0 ? void 0 : extractedObjects.map((obj) => {
            try {
                const parsedObject = JSON.parse(obj || '{}');
                return parsedObject['windowFunctions'];
            }
            catch (error) {
                console.error('Failed to get action functions from chunk: ', error);
                throw error;
            }
        });
        return _.flatten(actionFunctions);
    }
    else {
        return [];
    }
};
export const getChunkValue = (chunk, config) => {
    return (getValuesFromChunk(chunk, ChunkType.MESSAGE, config) ||
        getValuesFromChunk(chunk, ChunkType.PROGRESS_STATUS, config) ||
        getValuesFromChunk(chunk, ChunkType.ERROR, config) || { type: ChunkType.MESSAGE, value: '' });
};
export const addTargetBlanktoLinks = (markdown) => {
    const markdownLinkRegex = /\[([^\]]+)\]\(([^()\s]+(?:\([^)]*\)|\\[[^\]]*]|[^()\s])*)\)/g;
    const modifiedMarkdown = markdown.replace(markdownLinkRegex, (match, text, url) => {
        const escapedUrl = url.replace(/"/g, '&quot;');
        return `<a href="${escapedUrl}" target="_blank" rel="noopener noreferrer">${text}</a>`;
    });
    return modifiedMarkdown;
};
//# sourceMappingURL=helpers.js.map